<template>
    <div
        id="galleria-foto"
        v-bind:class="[isArticlesModalVisible ? 'bg-light popup-laterale-aperto' : 'bg-light']"
    >
        <vue-headful :title="pageTitle" />

        <div class="body-wrapper">
            <gallery-header
                ref="header"
                :header="'ALBUM_PHOTOS'"
                :title="title"
                :orderable="gallery && gallery.orderable"
                @albumPhotosBack="goBackToAlbum"
                @albumPhotosBuy="showArticlesModal"
            />

            <main>
                <div class="container-fluid">
                    <div class="galleria d-flex flex-column justify-content-between pt-3">
                        <div class="contenitore-foto d-flex justify-content-center flex-column flex-grow-1">
                            <div class="foto mw-100 mh-100 text-center">
                                <!--a href="#"-->
                                <img
                                    :src="currentPhotoUrl"
                                    alt=""
                                    class="mw-100 mh-100"
                                />
                                <!--/a-->
                            </div>
                        </div>
                        <div class="mt-1 mt-sm-0 mb-sm-1 mb-md-0">
                            <ul class="azioni-foto d-flex justify-content-around mb-0">
                                <li v-if="!isAuthor">
                                    <!-- ripeto l'anchor perché su device mobili non resetta lo stile dell'icona -->
                                    <a
                                        @click.prevent="onFavoriteToggle"
                                        href="#"
                                        class="active"
                                        v-show="this.currentPhoto && this.currentPhoto.isFavorite"
                                    >
                                        <font-awesome-icon :icon="['fas', 'star']" />&nbsp;{{ $t("Preferiti") }}
                                    </a>
                                    <a
                                        @click.prevent="onFavoriteToggle"
                                        href="#"
                                        v-show="!(this.currentPhoto && this.currentPhoto.isFavorite)"
                                    >
                                        <font-awesome-icon :icon="['fas', 'star']" />&nbsp;{{ $t("Preferiti") }}
                                    </a>
                                </li>
                            </ul>
                        </div>

                        <div class="d-flex justify-content-center d-sm-block mt-3 mt-sm-0 mb-1 mb-sm-0 contenitore-pulsanti">
                            <a
                                href="#"
                                @click.prevent="onPreviousPhotoClick"
                                class="mx-2 mx-sm-0"
                            >
                                <button class="pulsante-prev btn btn-dark btn-rikorda2 rounded-circle">
                                    <font-awesome-icon :icon="['fas', 'chevron-left']" />
                                </button>
                            </a>

                            <a
                                href="#"
                                @click.prevent="onNextPhotoClick"
                                class="mx-2 mx-sm-0"
                            >
                                <button class="pulsante-next btn btn-dark btn-rikorda2 rounded-circle">
                                    <font-awesome-icon :icon="['fas', 'chevron-right']" />
                                </button>
                            </a>
                        </div>
                    </div>

                    <div class="miniature-wrapper mt-3 pb-2 d-none d-md-block">
                        <div class="contenitore-miniature d-flex justify-content-center flex-column">
                            <a
                                href="#"
                                @click.prevent="onPreviousThumbsClick"
                            >
                                <button class="pulsante-prev btn btn-dark btn-rikorda2 rounded-circle">
                                    <font-awesome-icon :icon="['fas', 'chevron-left']" />
                                </button>
                            </a>

                            <a
                                href="#"
                                @click.prevent="onNextThumbsClick"
                            >
                                <button class="pulsante-next btn btn-dark btn-rikorda2 rounded-circle">
                                    <font-awesome-icon :icon="['fas', 'chevron-right']" />
                                </button>
                            </a>

                            <!--le miniature devono centrarsi in base a quella selezionata!-->
                            <ul
                                ref="thumbsContainer"
                                class="miniature mb-0 scrolling-wrapper"
                            >
                                <li
                                    v-for="photo in this.photos"
                                    :key="photo.id"
                                    ref="thumbList"
                                    class="foto mx-1 text-center h-100 d-inline-block"
                                    :class="{
                                        active: photo.id === currentPhotoId
                                    }"
                                >
                                    <a
                                        href="#"
                                        @click.prevent="
                                            onThumbClicked(photo.id)
                                        "
                                    ><img
                                            ref="imageList"
                                            src="/images/icons/loader.gif"
                                            :data-id="photo.id"
                                            :data-src="getUrl(photo.id)"
                                            alt=""
                                            class="mw-100 h-100"
                                        /></a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </main>

            <gallery-footer />
        </div>

        <b-overlay
            class="overlay"
            :show="isArticlesModalVisible"
            :variant="'dark'"
            :opacity="0.75"
            no-wrap
        >
            <template v-slot:overlay>
                <div></div>
            </template>
        </b-overlay>

        <articles-modal
            ref="articlesModal"
            v-show="isArticlesModalVisible"
            @close="hideArticlesModal"
        />
    </div>
</template>

<script>
import GalleryHeader from "../../components/gallery/Header";
import GalleryFooter from "../../components/gallery/Footer";
import ArticlesModal from "../../components/gallery/ArticlesModal";

export default {
    name: "GalleryAlbumPhotos",
    components: { GalleryHeader, GalleryFooter, ArticlesModal },

    data() {
        return {
            pageTitle: null,
            author: null,
            title: null,
            gallery: null,
            currentPhotoId: this.$route.params.photoId,
            currentPhotoUrl: null,
            currentPhoto: null,
            photos: [],
            photosList: [],
            isArticlesModalVisible: false,
            loadingCounter: 0,
            maxLoading: 2
        };
    },

    computed: {
        numPhotos() {
            return this.photos ? this.photos.length : 0;
        },

        isAuthor() {
            return this.$store.getters.isAuthor;
        }
    },

    mounted() {
        this.busy = true;
        this.$store
            .dispatch("GET_GALLERY_DATA", {
                albumId: this.$route.params.albumId
            })
            .then((result) => {
                console.debug("GET_GALLERY_DATA", result);
                this.gallery = result.gallery;
                this.photos = result.photos;
                this.photos.forEach((photo) => {
                    photo.loadingAllowed = false;
                });
                this.author = this.gallery.author;
                this.title = this.gallery.title;
                this.setPageTitle();
                this.updateCurrentPhoto(this.$route.params.photoId);
                this.$nextTick(() => {
                    this.handleLoading(this);
                });
            })
            .catch((error) => {
                console.error("GET_GALLERY_DATA", error);
                this.$router.push({
                    name: "gallery-dashboard",
                    params: {
                        galleryUrl: this.$route.params.galleryUrl
                    }
                });
            })
            .finally(() => {
                this.busy = false;
            });
    },

    methods: {
        setPageTitle() {
            if (this.gallery) {
                this.pageTitle = [
                    this.gallery.title,
                    this.$t("di"),
                    this.gallery.author,
                    "- Rikorda"
                ].join(" ");
            }
        },

        handleLoading(scope) {
            var photosToLoad = scope.photos.filter((p) => {
                return !p.loadingAllowed;
            });
            while (
                scope.loadingCounter < scope.maxLoading &&
                photosToLoad.length > 0
            ) {
                var photoToLoad = photosToLoad.shift();
                var el = scope.$refs["imageList"].filter((img) => {
                    return img.dataset.id == photoToLoad.id;
                });
                if (el.length > 0 && el[0].src.endsWith("loader.gif")) {
                    photoToLoad.loadingAllowed = true;
                    scope.loadingCounter++;

                    el[0].onload = scope.onImageLoaded;
                    el[0].src = el[0].dataset.src;
                }
            }

            if (photosToLoad.length > 0) {
                setTimeout(scope.handleLoading, 200, scope);
            }
        },

        onImageLoaded() {
            this.loadingCounter--;
        },

        getUrl(photoId) {
            return this.$imagesService.getUrl(photoId, "event-web", true);
        },

        updateCurrentPhoto(photoId) {
            var filteredPhotos = this.photos.filter((photo) => {
                return photo.id === photoId;
            });

            if (filteredPhotos.length) {
                this.currentPhotoId = photoId;
                this.currentPhoto = filteredPhotos[0];
                this.currentPhotoUrl = this.getUrl(this.currentPhotoId);

                var currentPhotoIndex = this.photos.indexOf(this.currentPhoto);

                history.replaceState(
                    {},
                    null,
                    this.$route.matched[0].path
                        .replace(":galleryUrl", this.$route.params.galleryUrl)
                        .replace(":albumId", this.$route.params.albumId)
                        .replace(":photoId", this.currentPhotoId)
                );

                if (this.$refs.thumbList) {
                    var el = this.$refs.thumbList[currentPhotoIndex];
                    el.scrollIntoView({
                        behavior: "smooth",
                        block: "nearest",
                        inline: "center"
                    });
                }
            }
        },

        onThumbClicked(photoId) {
            this.updateCurrentPhoto(photoId);
        },

        onPreviousPhotoClick() {
            var i = this.photos.indexOf(this.currentPhoto);
            if (i > 0 && i < this.photos.length) {
                this.updateCurrentPhoto(this.photos[i - 1].id);
            }
        },

        onNextPhotoClick() {
            var i = this.photos.indexOf(this.currentPhoto);
            if (i >= 0 && i < this.photos.length - 1) {
                var photo = this.photos[i + 1];
                this.updateCurrentPhoto(photo.id);
            }
        },

        onPreviousThumbsClick() {
            this.$refs.thumbsContainer.scrollLeft -= Math.floor(
                this.$refs.thumbsContainer.clientWidth / 2
            );
        },
        onNextThumbsClick() {
            this.$refs.thumbsContainer.scrollLeft += Math.floor(
                this.$refs.thumbsContainer.clientWidth / 2
            );
        },

        showArticlesModal() {
            this.$refs.articlesModal.photoData = this.currentPhoto;
            this.$refs.articlesModal.numPhotos = this.numPhotos;

            return this.$refs.articlesModal
                .getPriceSheetData()
                .then((result) => {
                    console.debug("GET_PRICE_SHEET_DATA", result);
                    this.isArticlesModalVisible = result;
                })
                .catch((error) => {
                    console.error("GET_PRICE_SHEET_DATA", error);
                });
        },

        hideArticlesModal() {
            this.isArticlesModalVisible = false;
        },

        goBackToAlbum() {
            this.$router.push({
                name: "gallery-album",
                params: {
                    galleryUrl: this.$route.params.galleryUrl,
                    albumId: this.$route.params.albumId
                }
            });
        },

        onFavoriteToggle() {
            this.$api
                .photoFavoriteToggle(this.currentPhotoId)
                .then((result) => {
                    this.currentPhoto.isFavorite = result.isFavorite
                        ? true
                        : false;
                })
                .catch((error) => {
                    console.error("ERROR:", error);
                });
        }
    }
};
</script>

<style scoped>
/*.scrolling-wrapper {
    display: flex;
    flex-wrap: nowrap;
    overflow-x: auto;
}
.scrolling-wrapper::-webkit-scrollbar {
    display: none;
}
.scrolling-wrapper .foto {
    flex: 0 0 auto;
}*/

/*.scrolling-wrapper {
    overflow-x: scroll;
    overflow-y: hidden;
    white-space: nowrap;
}
.scrolling-wrapper .foto {
    display: inline-block;
}
.miniature {
    padding-bottom: 0.25rem;
}*/
.scrolling-wrapper::-webkit-scrollbar {
    display: none;
}
</style>
